export const trimSlashes = (input: string = '') => input.replace(/^\/+|\/+$/g, '');

export const mergeURLParams = (baseUrl: string, addParams: Record<string, string>): string => {
    const url = new URL(baseUrl);
    Object.entries(addParams).forEach(([attr, value]) => {
        url.searchParams.append(attr, value);
    });
    return url.toString();
};

export const navigatedFromClub = (search: string): boolean => search.includes('utm_source=club');
